/* eslint-disable max-lines */
/* eslint-disable no-inline-comments */
import React, { Component } from "react";
import ReactDOM from "react-dom";
import { header } from "./common/header";
import { TopBanner } from "./common/TopBanner";
import { footer } from "./common/footer";
import { TYPE_PC, TYPE_SP } from "./common/defines";
import "./style.scss";
import { Area, AreaMap, AreaSelect, Detail, Top } from "./pages";
import { Carrieservice } from "./pages/area/Carrieservice";
import { Simulator } from "./pages/new/simulator";
import { WaitList } from "./pages/new/waitlist";
import { ModalMain } from "./common/modal";
import masterData from "./lib/masterData";
import { googleAnalytics } from "./lib/googleAnalytics";
import * as staticPages from "./pages/static";
import * as staticPages2 from "./pages/new";
import "@fortawesome/fontawesome-free/css/all.css";
import { MasterDataReady } from "./lib/masterData/MasterDataReady";
import "./lib/currentTime";
//import { getSynalio } from "./lib/synalio";

import { BrowserRouter, Route, Switch } from "react-router-dom";

import prefSlugs from "./common/prefSlugs";
import ScrollToTop from "./common/ScrollToTop";

const prefPattern = prefSlugs.join("|");

const basename = document.getElementsByTagName('base')[0].getAttribute('href')

// const utm_source = null;
// const utm_medium = null;
// const utm_campaign = null;
// const yclid = null;
// const gclid = null;
let last_url = location.href;
// function getParam(name, url) {
//   if (!url) {
//  url = window.location.href;
// }
//   name = name.replace(/[\[\]]/g, "\\$&");
//   const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
//       results = regex.exec(url);
//   if (!results) {
//  return null;
// }
//   if (!results[2]) {
//  return '';
// }
//   return decodeURIComponent(results[2].replace(/\+/g, " "));
// }

// function addParam(name, val, urlprams) {
//   if (urlprams.indexOf(name) == -1 && val != null) {
//     urlprams += (urlprams.indexOf('?') == -1) ? '?' : '&';
//     urlprams += name + '=' + val;
//   }
//   return urlprams;
// }

class App extends Component {
  constructor(props) {
    super(props);
    setTimeout(async () => {
      await masterData.prepareAll();
      this.setState({
        isload: true,
      });
      window.loadGtm();
    }, 2000);
    const queryDeviceType = this.getQueryDeviceType();
    this.state = {
      type: queryDeviceType || this.getDeviceType(),
      path: location.pathname,
      isload: false,
    };
    if (!queryDeviceType) {
      window.addEventListener("resize", () => {
        const deviceType = this.getDeviceType();
        if (this.state.type !== deviceType) {
          this.setState({
            type: deviceType,
          });
        }
      });
    }
  }
  componentDidMount() {
    this.mounted = true;
    this.refs.router.history.listen((location, action) => {
      const path = location.pathname + location.search + location.hash;
      this.setState({
        path: location.pathname,
      });
      setTimeout(() => {
        googleAnalytics.pageview({
          path,
          title: document.title,
        })
      }, 0)
    });
  }

  async componentDidUpdate() {
    // React内部からリニューアル後ページへ遷移の場合はReactで描画せずリロードしてLaravel側へ流す
    const uri = new URL(window.location.href);
    const customPattern = prefPattern + "|list/";
    if (uri.pathname == "/" || uri.pathname.search(customPattern) === 1) {
      // React側で描画させたくないのでtry-catchを使って処理を中断させる
      try {
        throw new Error();
      } catch (e) {
        if (uri.pathname.indexOf("/detail/") === -1) {
          //location.reload();
        }
      }
    }
    const current_url = location.href;

    if (last_url !== current_url) {
    //  console.log(last_url + 'から'+ current_url +'へ遷移');
      last_url = current_url;
      //const synalio = await getSynalio();
      //synalio.reloadEvent();
    }
  }

  getDeviceType() {
    return document.body.clientWidth > 1024 ? TYPE_PC : TYPE_SP;
  }
  // Prerendering用に内部で使われる
  // 初回表示時に設定され、ページ遷移時には反映されない
  getQueryDeviceType() {
    const paramsString = location.search;
    const searchParams = new URLSearchParams(paramsString);
    const deviceType = searchParams.get("deviceType");
    return deviceType && (deviceType !== 'sp' ? TYPE_PC : TYPE_SP);
  }
  //  実装済み
  //   /list/
  //   /(都道府県名)/list/

  //   /map/(物件番号).html
  //   /(都道府県名)/(市区町村名)/
  //   /line-(路線名)/
  //   /line-(路線名)/(駅名)/
  //   /(都道府県名)/search_campaign/list/
  //   /(都道府県名)/(市区町村名)/detail/(物件番号)

  render() {
    return (
      <BrowserRouter ref="router" basename={basename}>
        <ScrollToTop>
          <div
            id="wrapper"
            className={this.state.type === TYPE_PC ? "type_pc" : "type_sp"}
          >
            {header(this.state.type, this.state, this)}
            <TopBanner />
            <Switch>
              <Route
                exact
                path="/"
                render={props => (
                  <div className="top"><Top {...props} type={this.state.type} /></div>
                )}
              />
              <Route
                exact
                path="/app_chk"
                render={props => (
                  <div className="new">{staticPages2.app(this.state.type, "check")}</div>
                )}
              />
              <Route
                exact
                path="/app_inst"
                render={props => (
                  <div className="new">{staticPages2.app(this.state.type, "install")}</div>
                )}
              />
              <Route
                exact
                path="/:pageId(flow|faq|app|feature)"
                render={props => (
                  <div className="new">{staticPages2[props.match.params.pageId](this.state.type)}</div>
                )}
              />
              <Route
                exact
                path="/waitlist"
                render={props => (
                  <div className="new"><WaitList {...props} type={this.state.type} /></div>
                )}
              />
              <Route
                exact
                path="/simulator"
                render={props => (
                  <div className="new"><Simulator {...props} type={this.state.type} /></div>
                )}
              />
              <Route
                exact
                path="/beginner"
                render={props => (
                  <div className="new">{staticPages2.beginner(this.state.type)}</div>
                )}
              />
              <Route
                exact
                path="/carrieservice"
                render={props => (
                  <div className="new"><MasterDataReady><Carrieservice {...props} type={this.state.type}/></MasterDataReady></div>
                )}
              />
              <Route
                path="/beginner/:subpageId(case[1-3]|movie)/:tabId?"
                render={props => {
                  console.log(staticPages2, 'beginner_' + props.match.params.subpageId);
                  return <div className="new">{staticPages2['beginner_' + props.match.params.subpageId](this.state.type, props.match.params.tabId)}</div>
                }}
              />
              <Route
                exact
                path="/lineup"
                render={props => (
                  <div className="new">{staticPages2.lineup(this.state.type)}</div>
                )}
              />
              <Route
                path="/lineup/:subpageId?"
                render={props => (
                  <div className="new">{staticPages2.lineup_tab(this.state.type, props.match.params.subpageId, props.history)}</div>
                )}
              />
              <Route
                path="/beginner/lineup/:subpageId?"
                render={props => (
                  <div className="new">{staticPages2.lineup_tab(this.state.type, props.match.params.subpageId, props.history)}</div>
                )}
              />
              <Route
                exact
                path="/voice2"
                render={props => (
                  <div className="new">{staticPages2.voice(this.state.type, null, props.history)}</div>
                )}
              />
              <Route
                path="/voice2/:subpageId(voice_case[1-4])"
                render={props => (
                  <div className="new">{staticPages2[props.match.params.subpageId](this.state.type)}</div>
                )}
              />
              <Route
                path="/voice2/:subpageId"
                render={props => (
                  <div className="new">{staticPages2.voice(this.state.type, props.match.params.subpageId, props.history)}</div>
                )}
              />
              <Route
                // eslint-disable-next-line max-len
                path="/:pageId(corporate|about|agreement|asct|policy|privacy|service|sitemap|anshinpack|search_campaign|smartkey|trunkwithrack|newtrunkroom|concierge)"
                render={props => (
                  <div className="static">{staticPages[props.match.params.pageId](this.state.type)}</div>
                )}
              />
              {/*  /(都道府県名)/ */}
              <Route
                path={`/:pref(${prefPattern})`}
                exact
                render={props => (
                  <div className="area"><MasterDataReady><Area {...props} type={this.state.type} /></MasterDataReady></div>
                )}
              />
              {/*  /(都道府県名)/list */}
              <Route
                exact
                path={`/:pref(${prefPattern})/list`}
                render={props => (
                  <div className="area_map"><MasterDataReady><AreaMap {...props} type={this.state.type} /></MasterDataReady></div>
                )}
              />
              {/*  /(都道府県名)/(市区町村名)/ */}
              <Route
                exact
                path={`/:pref(${prefPattern})/:city([^l][a-z]*)/`}
                render={props => (
                  <div className="area_map"><MasterDataReady><AreaMap {...props} type={this.state.type} /></MasterDataReady></div>
                )}
              />
              {/*  /(都道府県名)/(市区町村名)/(行政区)/ */}
              <Route
                exact
                path={`/:pref(${prefPattern})/:city([^l][a-z]*)/:district([^l][a-z]*)/`}
                render={props => (
                  <div className="area_map"><MasterDataReady><AreaMap {...props} type={this.state.type} /></MasterDataReady></div>
                )}
              />
              {/*  /line-(路線名)/ */}
              <Route
                exact
                path={`/line-:line([^l][a-z-]*)/`}
                render={props => (
                  <div className="area_map"><MasterDataReady><AreaMap {...props} type={this.state.type} /></MasterDataReady></div>
                )}
              />
              {/*  /line-(路線名)/(駅名)/ */}
              <Route
                exact
                path={`/line-:line([^l][a-z-]*)/:station([^l][a-z-]*)`}
                render={props => (
                  <div className="area_map"><MasterDataReady><AreaMap {...props} type={this.state.type} /></MasterDataReady></div>
                )}
              />
              {/*  /都道府県/line-(路線名)/ */}
              <Route
                exact
                path={`/:pref(${prefPattern})/line-:line([^l][a-z-]*)/`}
                render={props => (
                  <div className="area_map"><MasterDataReady><AreaMap {...props} type={this.state.type} /></MasterDataReady></div>
                )}
              />
              {/*  /都道府県/line-(路線名)/(駅名)/ */}
              <Route
                exact
                path={`/:pref(${prefPattern})/line-:line([^l][a-z-]*)/:station([^l][a-z-]*)`}
                render={props => (
                  <div className="area_map"><MasterDataReady><AreaMap {...props} type={this.state.type} /></MasterDataReady></div>
                )}
              />
              {/*  /list */}
              <Route
                exact
                path={`/list`}
                exact
                render={props => (
                  <div className="area_select"><MasterDataReady><AreaSelect {...props} type={this.state.type} /></MasterDataReady></div>
                )}
              />
              <Route
                exact
                path={`/:pref(${prefPattern})/:city([^l][a-z]*)/detail/:asset`}
                render={props => (
                  <div className="detail">
                    <MasterDataReady schemaIds={["line", "city", "campaign", "station"]}>
                      <Detail {...props} type={this.state.type} />
                    </MasterDataReady>
                  </div>
                )}
              />
              <Route
                exact
                path={`/:pref(${prefPattern})/:city([^l][a-z]*)/:district([^l][a-z]*)/detail/:asset`}
                render={props => (
                  <div className="detail">
                    <MasterDataReady schemaIds={["line", "city", "campaign", "station"]}>
                      <Detail {...props} type={this.state.type} />
                    </MasterDataReady>
                  </div>
                )}
              />
              <Route
                render={props => (
                  <div className="static">{staticPages.notfound(this.state.type)}</div>
                )}
              />
            </Switch>
            {footer(this.state.type)}
            <ModalMain type={this.state.type} />
          </div>
        </ScrollToTop>
      </BrowserRouter>
    );
  }
}

const domReady = callback => {
  if (
    document.readyState === 'complete' ||
    (document.readyState !== 'loading' && !document.documentElement.doScroll)
  ) {
    callback();
  } else {
    document.addEventListener('DOMContentLoaded', callback);
  }
};

domReady(() => {
  const appElement = document.createElement("div");
  document.body.appendChild(appElement);
  ReactDOM.render(<App />, appElement);
});




// WEBPACK FOOTER //
// ./app.jsx